import { create } from 'zustand';

interface BoardPoint {
  x: number;
  y: number;
}

interface BoardRect extends BoardPoint {
  height: number;
  width: number;
}

interface BoardViewportState {
  clusterDraftRect: BoardRect | null;
  currentMousePosition: BoardPoint;
  dropPosition: BoardPoint | null;
  isPanning: boolean;
  startDragPosition: BoardPoint | null;
}

interface BoardViewportActions {
  setClusterDraftRect: (clusterDraftRect: BoardRect | null) => void;
  setCurrentMousePosition: (currentMousePosition: BoardPoint) => void;
  setDropPosition: (dropPosition: BoardPoint | null) => void;
  startPan: (startDragPosition: BoardPoint) => void;
  stopPan: () => void;
  resetBoardViewport: () => void;
}

export type BoardViewportStore = BoardViewportState & BoardViewportActions;

const initialState: BoardViewportState = {
  clusterDraftRect: null,
  currentMousePosition: { x: -1, y: -1 },
  dropPosition: null,
  isPanning: false,
  startDragPosition: null,
};

export const useBoardViewportStore = create<BoardViewportStore>((set) => ({
  ...initialState,
  setClusterDraftRect: (clusterDraftRect) => set({ clusterDraftRect }),
  setCurrentMousePosition: (currentMousePosition) => set({ currentMousePosition }),
  setDropPosition: (dropPosition) => set({ dropPosition }),
  startPan: (startDragPosition) => set({ isPanning: true, startDragPosition }),
  stopPan: () => set({ isPanning: false, startDragPosition: null }),
  resetBoardViewport: () => set(initialState),
}));
